import { TagAutomationRule } from '@apis/TagManager/model';
import { injectable } from 'tsyringe';

@injectable()
export class TagAutomationRuleReader {
    public getTagRuleCounts(rules: TagAutomationRule[]) {
        return rules.reduce((res, rule) => {
            for (const tag of this._getRuleTags(rule)) {
                res.set(tag, (res.get(tag) ?? 0) + 1);
            }
            return res;
        }, new Map<string, number>());
    }

    public getRuleTagLookup(rules: TagAutomationRule[]) {
        return rules.reduce((res, rule) => res.set(rule.Id!, new Set(this._getRuleTags(rule))), new Map<number, Set<string>>());
    }

    public getRuleTags(rule: TagAutomationRule) {
        return [...this._getRuleTags(rule)];
    }

    private *_getRuleTags(rule: TagAutomationRule) {
        const syntax = rule.Parameters?.Syntax;
        const tagSources = [
            ...(syntax?.AutoTagOptions?.map((o) => o.KeyToAdd ?? '') ?? []),
            ...(syntax?.AwsOUAccountGroupRuleOptions?.SelectedTags?.flatMap((t) => t.SelectedTags ?? []) ?? []),
            ...(syntax?.BulkTagOptions?.Headers ?? []),
            ...(syntax?.ReplacementOptions?.flatMap((o) => [o.KeyToCheck ?? '', o.KeyToReplace]) ?? []),
            ...(syntax?.ResourceGroupRuleOptions?.SelectedTags?.flatMap((t) => t.SelectedTags ?? []) ?? []),
            ...(syntax?.SyntaxOptions?.TagKeysToApplyTo ?? []),
        ];
        const yielded = new Set<string>();
        for (const item of tagSources) {
            if (item && !yielded.has(item)) {
                yield item;
                yielded.add(item);
            }
        }
    }
}
